// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"bce05645","213":"fc2d957e"}[chunkId] + ".chunk.js";
};